"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Suggestion = exports.Suggestions = exports.StyledInput = exports.Container = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _utils = require("../utils");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Container = _styledComponents["default"].div.withConfig({
  displayName: "inputParts__Container",
  componentId: "srl2ih-0"
})(["position:relative;width:100%;"]);

exports.Container = Container;

var disabledStyle = function disabledStyle() {
  return (0, _styledComponents.css)(["opacity:", ";cursor:default;"], function (props) {
    return props.theme.global.control.disabled.opacity;
  });
};

var StyledInput = _styledComponents["default"].input.withConfig({
  displayName: "inputParts__StyledInput",
  componentId: "srl2ih-1"
})(["box-sizing:border-box;font-size:inherit;-webkit-appearance:none;padding:", ";outline:none;background:transparent;color:", ";", " margin:0;", " ", "::-webkit-search-decoration{-webkit-appearance:none;}width:100%;", ";"], function (props) {
  return props.theme.global.input.padding;
}, function (props) {
  return props.theme.colorDefault;
}, function (props) {
  return props.theme.global.input.weight && (0, _styledComponents.css)(["font-weight:", ";"], props.theme.global.input.weight);
}, _utils.controlBorderStyle, function (props) {
  return props.focus && (!props.plain || props.focusIndicator) && _utils.focusStyle;
}, function (props) {
  return props.disabled && disabledStyle;
});

exports.StyledInput = StyledInput;

var Suggestions = _styledComponents["default"].div.withConfig({
  displayName: "inputParts__Suggestions",
  componentId: "srl2ih-2"
})([""]);

exports.Suggestions = Suggestions;

var Suggestion = _styledComponents["default"].div.withConfig({
  displayName: "inputParts__Suggestion",
  componentId: "srl2ih-3"
})(["cursor:pointer;padding:", ";:hover{color:", ";background-color:", ";}", ""], function (props) {
  return props.theme.suggestion.padding;
}, function (props) {
  return props.theme.suggestion.hover.color;
}, function (props) {
  return props.theme.suggestion.hover.backgroundColor;
}, function (props) {
  return props.active && (0, _styledComponents.css)(["color:", ";background-color:", ";"], props.theme.suggestion.hover.color, props.theme.suggestion.hover.backgroundColor);
});

exports.Suggestion = Suggestion;